import CalloutCard from 'components/Callouts/CalloutCard/CalloutCard';
import KeyLine from 'components/shared/KeyLine';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { CalloutIconProps } from 'components/Callouts/types';
import { KeyLinePosition, CopyJustification } from 'types/constants';
import { getCalloutColumns, getCustomBackgroundColor, getSectionProps } from 'utils/styles';
import Image from 'next/image';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const CalloutIcon = ({
  sys,
  content,
  headline,
  sectionName,
  columns,
  color,
  keyLine,
  margins,
  copyJustification,
}: CalloutIconProps) => {
  const showKeylineUnderHeadline = keyLine === KeyLinePosition.Between || keyLine === KeyLinePosition.Top;
  const showTopKeylineDesktop = keyLine === KeyLinePosition.Top;
  const showBetweenKeylines = keyLine === KeyLinePosition.Between;

  const imageWrapperClasses = cn(
    'flex max-md:flex-shrink-0 max-sm:basis-10 sm:basis-18 sm:w-18 sm:h-18 sm:mt-5 items-start',
    copyJustification === CopyJustification.Center ? 'sm:mx-auto' : '',
  );

  return (
    <section {...getSectionProps(color, margins, sectionName)} style={getCustomBackgroundColor(color)}>
      <div className="content-wrapper">
        <div className="flex flex-col items-start w-full gap-8">
          {headline && (
            <div className="text-heading-lg font-sans font-semibold md:w-1/2" {...liveUpdateAttrs(sys?.id, 'headline')}>
              <RichTextHeadline headline={headline} />
            </div>
          )}
          <div className="block sm:hidden w-full">{showKeylineUnderHeadline && <KeyLine />}</div>
          <div
            className="flex flex-col sm:flex-row sm:flex-wrap items-stretch gap-6 md:gap-y-40 w-full"
            {...liveUpdateAttrs(sys?.id, 'content')}>
            {(content?.items ?? []).map((item, index) => (
              <CalloutCard
                sys={sys}
                key={index}
                showTopKeylineDesktop={showTopKeylineDesktop}
                showTopKeylineMobile={false}
                showBetweenKeylines={showBetweenKeylines}
                className={getCalloutColumns(columns)}
                headline={item.headline}
                headlineSmallRte={item.headlineSmallRte}
                copy={item.copy}
                attributionRte={item.attributionRte}
                copyJustification={copyJustification}
                link={item.link}>
                {item.icon && (
                  <div className={`${imageWrapperClasses}`} {...liveUpdateAttrs(sys?.id, 'icon')}>
                    <Image
                      src={item.icon.url}
                      alt={item.icon.title}
                      height={256}
                      width={256}
                      className="max-h-[100%] callout-icon"
                    />
                  </div>
                )}
              </CalloutCard>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalloutIcon;
